/**
 * Header row of the downloadable product-import CSV. The column names must
 * match what the API importer reads (products.service processImportJob):
 * stock is `stock_quantity`, and variants link via `parent_sku` + `variant_*`.
 * `enable_at` (location codes, `;`-separated) adds a row to those stores
 * instead of the ones picked on the page; `store_price` is each of those
 * stores' own price. `price`, `cost` and `store_price` are plain numbers in
 * the currency's major unit (199.50, not 19950), with no symbol or comma.
 */
export const PRODUCT_IMPORT_TEMPLATE_HEADERS = [
  'name',
  'sku',
  'barcode',
  'category',
  'price',
  'cost',
  'gst_rate',
  'hsn_code',
  'unit',
  'stock_quantity',
  'low_stock_threshold',
  'parent_sku',
  'variant_size',
  'variant_color',
  'variant_material',
  'enable_at',
  'store_price',
] as const;

export const PRODUCT_IMPORT_TEMPLATE_CSV = `${PRODUCT_IMPORT_TEMPLATE_HEADERS.join(',')}\n`;
